export const hasSparepartsLoad = item => {
  const loads = [item?.loads, item?.loads_ori, item?.loads_extra, item?.extloads]
    .filter(Boolean)
    .join(' ')
    .replace(/<[^>]+>/g, ' ')
    .toLowerCase();

  // cocokkan "sparepart" / "spareparts" (case-insensitive)
  return loads.includes('sparepart');
};

export const getOrderLoadsLabel = item => {
  const parts = [item?.loads, item?.loads_extra, item?.extloads]
    .filter(Boolean)
    .map(v =>
      String(v)
        .replace(/<br\s*\/?>/gi, ' · ')
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    )
    .filter(Boolean);

  return parts.join(' · ');
};
